function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.8 6.388a.688.688 0 00-.974 0L5.7 10.513a.688.688 0 000 .974l4.125 4.125a.688.688 0 10.973-.974L7.16 11l3.64-3.638a.687.687 0 000-.974z"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.5 11a.687.687 0 00-.688-.688H6.876a.687.687 0 100 1.376h8.938A.687.687 0 0016.5 11z"
});
function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22"
  }, props), _ref, _ref2);
}
export default SvgArrowLeft;